module.exports = __webpack_public_path__ + "img/close-round-icon.aeb4b378.png";